import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PermissionState {
  isSuperAdminPanel: boolean;
}

const getInitialState = (): PermissionState => {
  if (typeof window !== "undefined") {
    // Only access localStorage on the client
    return {
      isSuperAdminPanel: Boolean(
        JSON.parse(localStorage.getItem("isSuperAdminPanel") || "false"),
      ),
    };
  }
  return { isSuperAdminPanel: false }; // Default state for SSR
};

const initialState: PermissionState = getInitialState();

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setSuperAdminPanel(state, action: PayloadAction<boolean>) {
      state.isSuperAdminPanel = action.payload;
      if (typeof window !== "undefined") {
        // Only update localStorage on the client
        localStorage.setItem(
          "isSuperAdminPanel",
          JSON.stringify(action.payload),
        );
      }
    },
  },
});

export const { setSuperAdminPanel } = permissionSlice.actions;
export default permissionSlice.reducer;
